// src/components/Layout/LogoutButton.js
import React from 'react';
import LogoutIcon from '@mui/icons-material/Logout';

export default function LogoutButton({ onLogout }) {
  return (
    <div id="logout-button" className="fixed right-2 top-2 z-50">
      <LogoutIcon onClick={onLogout} />
    </div>
  );
}
